import { autoinject } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

@autoinject
export class EmailApi {

    constructor(private requestClient: RequestClientService, private configService: ConfigService){}

    public resendEmail(emailHistoryId: number): Promise<boolean> {
        return this.requestClient.post<boolean>(`${this.configService.config.urls.rightShipPlatformApiUrl}/resendEmail`, { emailHistoryId })
    }
}
